import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled(Form)`
  display: flex;
  flex-direction: column;

  .text-area textarea {
    background-color: var(--white);
    border: 1px solid var(--blue);
    border-radius: 0.2rem;
  }

  .text-area textarea::placeholder {
    color: var(--gray);
  }

  .evaluate-product-name {
    text-align: center;
    font-size: 0.9rem;
    font-weight: 500;
    margin-bottom: 0.6rem;
    color: var(--gray_medium_bold);
  }

  .evaluate-product-group {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    font-size: 0.9rem;
    font-weight: 500;
    margin: 1rem 0;
    color: var(--gray_medium_bold);

    .icon.regStar-icon {
      width: 1.4rem;
      height: 1.4rem;
    }
  }
`;
